export default "/images/vendor/@coreui/icons/svg/flag/cif-gr.svg?a0eaffa7a39eb0ff36a36e3968e6b867";